import React from "react";
import { Eye, EyeOff } from "lucide-react";

export const ChartLegend = ({ showCompanyReports, onToggleCompanyReports, hasForecast, showForecast, onToggleForecast }) => {
    return (
        <div className="flex items-center gap-4 text-xs text-cm-p-text-secondary">
            <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-[#5fd8aa]/20" />
                <span>Min-Max range</span>
            </div>
            <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#24B98C]" />
                <span>Market</span>
            </div>
            <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-cm-p-graph-company" />
                <span>Company Reports</span>
                <button
                    onClick={onToggleCompanyReports}
                    className="ml-1 text-cm-p-text-secondary hover:text-cm-p-text-primary transition-colors"
                    aria-label={showCompanyReports ? "Hide company reports" : "Show company reports"}
                >
                    {!showCompanyReports ? <Eye size={16} /> : <EyeOff size={16} />}
                </button>
            </div>
            {hasForecast ? (
                <div className="flex items-center gap-2">
                    <div className="relative w-3 h-3">
                        <div className="absolute inset-0 bg-cm-p-graph-high-perf-30 opacity-30" />
                        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 border-t-2 border-dashed border-cm-p-graph-high-perf" />
                    </div>
                    <span>12-month forecast</span>
                    <button
                        onClick={onToggleForecast}
                        className="ml-1 text-cm-p-text-secondary hover:text-cm-p-text-primary transition-colors"
                        aria-label={showForecast ? "Hide 12-month forecast" : "Show 12-month forecast"}
                    >
                        {!showForecast ? <Eye size={16} /> : <EyeOff size={16} />}
                    </button>
                </div>
            ) : null}
        </div>
    );
};
